import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../icon';
import Paragraph from '../../paragraph';
import TextSkeleton from '../../skeletons/text-skeleton';
import { Popover, PopoverTrigger, PopoverContent } from '../../popover';

const MainRowItem = ({
  title,
  tooltip = null,
  loading = false,
  disabled = false,
  onTooltipHover = Function.prototype,
}) => {
  const mainRowItemClasses = classNames('ws-ui-main-row-item');

  return (
    <div className={mainRowItemClasses}>
      <div className="ws-ui-main-row-item__title-wrapper">
        <Paragraph appearance={disabled ? 'low-emphasis' : 'high-emphasis'}>
          {loading ? <TextSkeleton width="128px" /> : <strong>{title}</strong>}
        </Paragraph>
      </div>
      <div className="ws-ui-main-row-item__tooltip-wrapper">
        {loading ? (
          <Paragraph>
            <TextSkeleton width="24px" />
          </Paragraph>
        ) : (
          Boolean(tooltip) && (
            <Popover placement="right-center" onHover={onTooltipHover} description={tooltip}>
              <PopoverTrigger>
                <Icon glyph="info" type="light" />
              </PopoverTrigger>
              <PopoverContent />
            </Popover>
          )
        )}
      </div>
    </div>
  );
};

MainRowItem.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onTooltipHover: PropTypes.func,
};

export default MainRowItem;
